import React, { Component } from "react";
import { Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import moment from "moment/moment";
import { Header, Panel, toaster, Message, Button } from "rsuite";

const Card = (props) => <Panel {...props} bordered></Panel>;

export class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usuario: JSON.parse(localStorage.getItem("auth")).nombre,
    };
  }

  getCookie = (name) => {
    const cookies = document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${name}=`));

    return cookies ? cookies.split("=")[1] : null;
  };

  validSession() {
    var sessionID = this.getCookie("sessionID");
    var expira = this.getCookie("expira");
    var dateIsAfter = moment(new Date()).isAfter(moment(expira));

    if (sessionID.length === 0) {
      window.location = `/#/Login`;
      window.location.reload();
    }

    if (expira.length > 0) {
      if (dateIsAfter) {
        window.location = `/#/Login`;
        window.location.reload();
      }
    }
  }

  cerrarSesion = () => {
    this.deleteCookies();
    window.location = `/#/Login`;
  };

  deleteCookies = () => {
    document.cookie = `sessionID=;`;
    document.cookie = "expira=;";
  };

  validaAcceso = (idForm) => {
    var permisos = JSON.parse(localStorage.getItem("auth")).permisos;
    var lenPermisos = permisos!=null ? permisos.length : 0;
    var existe = false;
    for (let index = 0; index < lenPermisos; index++) {
      const element = permisos[index].IdForm;
      if (element === idForm) {
        existe = true;
      }
    }
    if(!existe){ this.toast("No cuenta con el permiso para ingresar a esta opción.", "warning"); }else{
      if(idForm === 1) { window.location = "#/Menu/DatosCarrera"; }
      if(idForm === 2) { window.location = "#/Menu/ConsultaRegistrados"; }
      if(idForm === 3) { window.location = "#/Menu/ResumenIngresos"; }
    }
    
  };

  toast = (msg, type = "info") => {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 5000, placement: "topCenter" }
    );
  };

  render() {
    this.validSession();
    const { usuario, permisos } = this.state;
    return (
      <div
        style={{
          backgroundImage: "url(Images/backInicio.jpg)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "100%",
          height: "auto",
          position: "fixed",
          top: 0,
          height: "100%",
          width: "100%",
          overflow: "auto",
        }}
      >
        <div
          className="container"
          style={{
            margin: "auto",
            marginTop: "5%",
            width: "60%",
            marginLeft: "20%",
            padding: "10px",
          }}
        >
          <Header
            style={{
              backgroundColor: "#f9f7f6",
              height: "auto",
              padding: "20px",
              borderRadius: "15px",
              width: "auto",
              opacity: 0.8,
            }}
          >
            <div className="row">
              <div className="text-center col-lg-3 col-md-3 col-sm-3">
                <Card
                >
                  <Button appearance="link" onClick={() => this.validaAcceso(1)}><b style={{color: '#1675e0'}}>Datos Carrera</b></Button>
                  <Image
                    src="/Images/datos.jpg"
                    width={"120px"}
                    height={"100px"}
                    style={{ borderRadius: "10px" }}
                  />
                </Card>
              </div>
              <div className="text-center col-lg-3 col-md-3 col-sm-3">
                <Card>
                <Button appearance="link" onClick={() => this.validaAcceso(2)}><b style={{color: '#1675e0'}}>Consulta de inscripciones</b></Button>
                  <Image
                    src="/Images/bikers.jpg"
                    width={"120px"}
                    height={"100px"}
                    style={{ borderRadius: "10px" }}
                  />
                </Card>
              </div>
              <div className="text-center col-lg-3 col-md-3 col-sm-3">
                <Card>
                <Button appearance="link" onClick={() => this.validaAcceso(3)}><b style={{color: '#1675e0'}}>Conciliación de ingresos</b></Button>
                  <Image
                    src="/Images/resumenIngresos.jpg"
                    width={"120px"}
                    height={"100px"}
                    style={{ borderRadius: "10px" }}
                  />
                </Card>
              </div>
              <div className="text-center col-lg-3 col-md-3 col-sm-3">
                <Card>
                <Button appearance="link" onClick={() => this.cerrarSesion()}><b style={{color: '#1675e0'}}>Cerrar Sesión</b></Button>
                  <Image
                    src="/Images/cerrar.jpg"
                    width={"120px"}
                    height={"100px"}
                    style={{ borderRadius: "10px" }}
                  />
                </Card>
              </div>
            </div>
            <br></br>
            <center>Sesión iniciada: {usuario}</center>
            <br></br>
            <center>
              <b style={{ fontSize: "11px", color: "#1684e0" }}>
                <a href="https://www.radyxxa.com.mx" target="_blank">
                  Designed by RADYXXA
                </a>
              </b>
            </center>
          </Header>
        </div>
      </div>
    );
  }
}
